const config = require('./configs/merchant');
const User = require('./user');
const RequestError = require('./requestError');
const snakeToCamel = require('./utils/snakeToCamel');
const deepExtend = require('./utils/deepExtend');

function Merchant(options) {
  const merchant = new User(deepExtend({}, config, options));

  /**
   *
   */
  merchant.registrationBegin = function(
    email,
    password,
    phoneNumber = null,
    fullName = null,
    kwargs = {}
  ) {
    return this.registrationManger
      .create(email, password, phoneNumber, fullName, kwargs)
      .catch(function(error) {
        throw new RequestError(error);
      });
  };

  /**
   *
   */
  merchant.registrationUpdate = function(data) {
    const companyFieldNames = [
      'legal_business_name',
      'business_support_email',
      'business_support_phone_number',
      'line1',
      'line2',
      'city',
      'country_id',
      'postcode',
      'license_number',
      'license_expired_at',
      'trn_number',
      'website_url',
      'ecommerce_platform',
      'yearly_sales',
      'average_order_value',
      'business_sector',
    ];
    const employeeFieldNames = ['first_name', 'last_name', 'phone_number'];
    const processFields = (obj, field) => {
      const fieldCamel = snakeToCamel(field);
      obj[field] = data[fieldCamel];
      return obj;
    };

    // Prepare data in sent data with proper formatting
    const profile = companyFieldNames.reduce(processFields, {});
    const employee = employeeFieldNames.reduce(processFields, {});

    return this.registrationManger.update({ profile, employee }).catch(function(error) {
      throw new RequestError(error);
    });
  };

  /**
   *
   */
  merchant.registrationValidate = function() {
    return this.registrationManger.validate().catch(function(error) {
      throw new RequestError(error);
    });
  };

  /**
   *
   */
  merchant.registrationVerification = function(code) {
    return this.registrationManger
      .verify(code)
      .then(function(data) {
        return data.token;
      })
      .catch(function(error) {
        throw new RequestError(error);
      });
  };

  return merchant;
}

module.exports = Merchant;
